"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'email.payment.success.subject': 'Pagamento riuscito - Abbonamento confermato',
    'email.payment.success.title': 'Pagamento elaborato con successo!',
    'email.payment.success.text': 'Grazie per il tuo pagamento. Il tuo abbonamento è stato confermato ed è ora attivo.',
    'email.payment.success.confirmation': 'Riceverai una ricevuta per questo pagamento a breve.',
    'email.payment.success.footer': 'Se hai domande, contatta il nostro team di supporto.',
    'email.payment.failed.subject': 'Pagamento fallito - Azione richiesta',
    'email.payment.failed.title': 'Elaborazione pagamento fallita',
    'email.payment.failed.text': 'Non siamo riusciti a elaborare il tuo pagamento per il tuo abbonamento. Aggiorna il tuo metodo di pagamento per continuare a utilizzare i nostri servizi.',
    'email.payment.failed.retry_text': 'Per evitare l\'interruzione del servizio, riprova il pagamento il prima possibile.',
    'email.payment.failed.retry_button': 'Riprova pagamento',
    'email.payment.failed.support_button': 'Contatta supporto',
    'email.payment.failed.footer': 'Se continui ad avere problemi, contatta il nostro team di supporto per assistenza.',
    'email.payment.plan': 'Piano di abbonamento',
    'email.payment.amount': 'Importo',
    'email.payment.next_billing': 'Prossima data di fatturazione',
    'email.payment.failure_reason': 'Motivo del fallimento',
    'email.payment.dashboard_button': 'Visualizza Dashboard',
    'email.payment.download_invoice': 'Scarica fattura',
};
